import React from "react";
import { useNavigate } from "react-router-dom";
import AttractScreenCarousel from "../components/AttractScreenCarousel";
import AttractCTA from "../components/AttractCTA";

// Nespresso brand colors
const NESPRESSO = {
  black: "#000000",
  gold: "#c69f36",
};

const NespressoBeforeStartView: React.FC = () => {
  const navigate = useNavigate();

  const handleScanClick = () => {
    // Per spec: After scanning loyalty card, go to welcome screen (which includes checklist)
    navigate("takeback");
  };

  const handleCarouselInteraction = () => {
    // Could log analytics or trigger other side effects
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: NESPRESSO.black }}
    >
      {/* Header - Minimal branding */}
      <header className="py-4 px-8 flex items-center justify-center">
        <span
          className="font-medium uppercase tracking-widest text-sm"
          style={{ color: NESPRESSO.gold }}
        >
          Nespresso Recycling Program
        </span>
      </header>

      {/* Main Content - Carousel */}
      <main className="flex-1 relative">
        <div className="absolute inset-0">
          <AttractScreenCarousel
            intervalMs={6000}
            onInteraction={handleCarouselInteraction}
          />
        </div>
      </main>

      {/* Footer CTA */}
      <AttractCTA
        onScanClick={handleScanClick}
        signupQRValue="https://nespresso.com/recycling/signup"
      />

      {/* Powered by footer */}
      <footer className="py-3 px-8 text-center text-white/30 text-xs border-t border-white/5 font-light">
        Powered by Pentatonic AI
      </footer>
    </div>
  );
};

export default NespressoBeforeStartView;
